/* jshint esversion: 6, -W097 */
/* globals require */
(function (angular) {
    'use strict';

    const constants = require('@utils/_constants');
    /**
     * Rebates modal related services
     */
    angular
        .module('enervee.fastTrack')
        .factory('FastTrackModalService', FastTrackModalService);

    FastTrackModalService.$inject = [
        '$uibModal',
        '$uibModalStack',
        '$state',
        'AnalyticsService',
        'CategoriesService',
        'EnerveeRebateService',
        'FastTrackProductsModalService',
        'FastTrackUploadReceiptsService',
        'RebatesService',
        'SwiftypeService',
        'UtilService',
        'CookiesService',
    ];

    function FastTrackModalService(
        $uibModal,
        $uibModalStack,
        $state,
        AnalyticsService,
        CategoriesService,
        EnerveeRebateService,
        FastTrackProductsModalService,
        FastTrackUploadReceiptsService,
        RebatesService,
        SwiftypeService,
        UtilService,
        CookiesService,
    ) {
        var _pub = {};
        var currentModal = null;

        var productsModalTemplate = require('@app/components/fastTrack/productsModal/fastTrackProductsModalView.html');
        var waitingModalTemplate = require('@app/components/fastTrack/waitingModal/fastTrackWaitingModalView.html');
        var uploadReceiptsModalTemplate = require('@app/components/fastTrack/uploadReceiptsModal/fastTrackUploadReceiptsModalView.html');
        var errorsModalTemplate = require('@app/components/fastTrack/errorsModal/fastTrackErrorsModalView.html');
        var successModalTemplate = require('@app/components/fastTrack/successModal/fastTrackSuccessModalView.html');

        var STEP_PRODUCT_SELECTION = 'product-selection';
        var STEP_APPLICATION = 'rebates-application';
        var STEP_ERROR_VERIFICATION_FAILED = 'error-verification-failed';
        var STEP_ERROR_NO_AVAILABLE_REBATES = 'error-no-available-rebates';
        var STEP_SUCCESS = 'success-message';
        var STEP_UPLOAD_RECEIPT = 'upload-receipts';
        var STEP_WAITING = 'waiting';
        var uibModalStack = $uibModalStack;

        _pub.currentStep = STEP_PRODUCT_SELECTION;
        _pub.openModal = openModal;
        _pub.openRebateApplication = openRebateApplication;
        _pub.switchViews = switchViews;
        _pub.onApplicationFormComplete = onApplicationFormComplete;

        /**
         * Handles the fast track button click. If the instant rebate url is set,
         * we open that url in a new tab. Otherwise, open the first modal in the
         * fast track process.
         *
         * @param {Product[]} [productArray] - An optional array of products to
         *                                     populate the modal with.
         */
        _pub.showFastTrackModal = function (location='', productArray) {
            if (angular.isDefined(productArray)) {
                FastTrackProductsModalService.setProducts(productArray);
            }

            /**
             * Track that the user opened the fast track modal.
             */
            AnalyticsService.reportEvent('Claim Rebate Engaged', {
                location: location,
            });
            switchViews(STEP_PRODUCT_SELECTION);
        };

        /**
         * Opens a modal depending on the specified controller and template.
         *
         * @param modalController
         * @param modalTemplate
         * @param initialScope
         */
        function openModal(modalController, modalTemplate, initialScope) {
            currentModal = $uibModal.open({
                animation: true,
                backdrop: 'static',
                ariaLabelledBy: 'modal-fast-track',
                ariaDescribedBy: 'modal-body',
                template: modalTemplate,
                controller: modalController,
                windowClass: 'powered-by',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    initialScope: function () {
                        return initialScope;
                    }
                }
            }).result.then(function (response) {
                /**
                 * @TODO: It is a mocked process which needs to be removed
                 * @type {string}
                 */
                _pub.switchViews(STEP_APPLICATION);
            });
        }

        /**
         * Sets the iframe source url and opens it
         */
        function openRebateApplication() {
            var applicationTriggerSource = 'fast track 2.0';
            EnerveeRebateService.openApplicationForm(applicationTriggerSource).then(onApplicationFormComplete);
        }

        /**
         * Logic to switch between modals views and the RRAPI iframe
         */
        function switchViews(currentStep, modalInitialScope) {

            if (!modalInitialScope) {
                modalInitialScope = {
                };
            }

            // close waiting modal before opening another modal
            uibModalStack.dismissAll();

            switch (currentStep) {
                case STEP_PRODUCT_SELECTION:
                    // choose products
                    _pub.openModal('fastTrackProductsModalCtrl', productsModalTemplate, modalInitialScope);
                    break;
                case STEP_WAITING:
                    _pub.openModal('fastTrackWaitingModalCtrl', waitingModalTemplate, modalInitialScope);
                    break;
                case STEP_UPLOAD_RECEIPT:
                    FastTrackUploadReceiptsService.setRebatedProducts(modalInitialScope.products, modalInitialScope.rebates);
                    _pub.openModal('fastTrackUploadReceiptsModalCtrl', uploadReceiptsModalTemplate, modalInitialScope);
                    break;
                case STEP_ERROR_NO_AVAILABLE_REBATES:
                    FastTrackUploadReceiptsService.setRebatedProducts(modalInitialScope.products, modalInitialScope.rebates);
                    modalInitialScope.errorType = 'error-no-available-rebates';
                    modalInitialScope.switchViews = _pub.switchViews;
                    _pub.openModal('fastTrackErrorsModalCtrl', errorsModalTemplate, modalInitialScope);
                    break;
                case STEP_ERROR_VERIFICATION_FAILED:
                    modalInitialScope.errorType = 'error-verification-failed';
                    modalInitialScope.switchViews = _pub.switchViews;
                    _pub.openModal('fastTrackErrorsModalCtrl', errorsModalTemplate, modalInitialScope);
                    break;
                case STEP_SUCCESS:
                    // We've completed the Fast Track process, let's clear out the products from the service.
                    FastTrackProductsModalService.setProducts();
                    // Now check if next best action page feature is enabled to determine if we should redirect to it.
                    if (UtilService.isFeatureEnabled('next_best_action_claim_summary')) {
                        $state.go('claim-summary');
                    } else {
                        _pub.openModal('fastTrackSuccessModalCtrl', successModalTemplate, modalInitialScope);
                    }
                    break;
                case STEP_APPLICATION:
                    // RRAPI application form
                    _pub.openRebateApplication();
                    break;
                default:
                    break;
            }

            _pub.currentStep = currentStep;
        }

        /**
         * This function is run when the iframe is complete, both successfully or not.
         * @param data - data returned from the iframe
         */
        function onApplicationFormComplete(data) {
            if (data.reason === 'formComplete') {
                determineApplicationState(data.data);
            }
       }

        /**
         * Determines whether it should show any of the error pages or the upload receipts page, and then
         * gets all the necessary data to render the appropriate page.
         * @param data
         */
        function determineApplicationState(data) {
            if (data.utility_verification && data.is_valid) {
                removeValidationBypassCodeCookie();
                _pub.switchViews(STEP_WAITING);
                EnerveeRebateService.fetchBestRebates(data.application_id).then(function (rebatedProducts) {
                    // For compatibility with cart item directive (now expects a list of rebates)
                    RebatesService.addRebatesProperty(rebatedProducts);
                    var rebateData = determineProductRebateData(rebatedProducts);
                    if (rebateData.hasValidRebates) {
                        SwiftypeService.getProducts(rebateData.categoryCodesToProductIds, false).then(function (products) {
                            _pub.switchViews(STEP_UPLOAD_RECEIPT, {
                                'products': products,
                                'rebates': rebateData.productIdsToBestRebate,
                                'switchViews': _pub.switchViews
                            });
                        });
                    } else {
                        var trackingData = {
                            process_type: 'fast track 2.0',
                            process_step: 'get rebates',
                            process_failure_reason: 'no available rebates'
                        };
                        RebatesService.trackIncentiveEngaged(
                            'Failed',
                            trackingData,
                            FastTrackProductsModalService.retrieveRawProducts()
                        );
                        SwiftypeService.getProducts(rebateData.categoryCodesToProductIds, false).then(function (products) {                         
                            _pub.switchViews(STEP_ERROR_NO_AVAILABLE_REBATES,  {
                                'products': products,
                                'rebates': rebateData.productIdsToBestRebate,
                                'switchViews': _pub.switchViews
                            });
                        });
                    }
                });
            } else {
                var trackingData = {
                    process_type: 'fast track 2.0',
                    process_step: 'verification',
                    process_failure_reason: 'verification failed'
                };
                RebatesService.trackIncentiveEngaged(
                    'Failed',
                    trackingData,
                    FastTrackProductsModalService.retrieveRawProducts()
                );
                _pub.switchViews(STEP_ERROR_VERIFICATION_FAILED);
            }
        }

        /**
         * Remove claim validation bypass code cookie.
         */
        function removeValidationBypassCodeCookie() {
            CookiesService.remove(constants.CLAIM_VALIDATION_BYPASS_CODE);
        }

        /**
         * Determines if the given products have any valid rebates
         * @param rebatedProducts
         * @returns {boolean}
         */
        function determineProductRebateData(rebatedProducts) {
            var returnData = {
                categoryCodesToProductIds: {},
                hasValidRebates: false,
                productIdsToBestRebate: {}
            };

            if (Array.isArray(rebatedProducts)) {
                rebatedProducts.forEach(function (rebatedProduct) {
                    if (rebatedProduct.rebate_id && (rebatedProduct.rebate_quantity > 0)) {
                        returnData.hasValidRebates = true;
                    }
                    var category = CategoriesService.getCategoryById(rebatedProduct.category_id);
                    var categoryCode = category.code;
                    if (categoryCode in returnData.categoryCodesToProductIds) {
                        returnData.categoryCodesToProductIds[categoryCode].push(rebatedProduct.product_id);
                    } else {
                        returnData.categoryCodesToProductIds[categoryCode] = [];
                        returnData.categoryCodesToProductIds[categoryCode].push(rebatedProduct.product_id);
                    }

                    returnData.productIdsToBestRebate[rebatedProduct.product_id] = rebatedProduct;

                });
            }

            return returnData;
        }

        return _pub;
    }

})(angular);
